// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"228":"5b5fa06c","305":"853b390c","863":"5b748bb2"}[chunkId] + ".chunk.js";
};